import { UserRoleView } from '@api-proxies';
import { UserRoleService } from '@http/clients/user-role.service';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class UserRoleEntity<TEntityDestination>
    implements IComponentEditorEntity<UserRoleView, TEntityDestination>
{
    constructor(readonly userRoleService: UserRoleService) {}

    abstract toDestination(entity: UserRoleView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): UserRoleView;

    abstract getSource(): Promise<UserRoleView[]>;
}
